import { render, staticRenderFns } from "./OvationSurveyModal.vue?vue&type=template&id=0961cc73"
import script from "./OvationSurveyModal.vue?vue&type=script&lang=js"
export * from "./OvationSurveyModal.vue?vue&type=script&lang=js"
import style0 from "./OvationSurveyModal.vue?vue&type=style&index=0&id=0961cc73&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports